import * as React from 'react';

import c4bLogo from 'images/ent-website/enterprise-logo.svg';

import _t from 'i18n!nls/ent-website';

function EnterpriseLogo() {
  return <img src={c4bLogo} width={240} alt={_t('Coursera for Enterprise')} />;
}

export default EnterpriseLogo;
